import { Shelf, sides, wardrobeTemplates } from '@/Interfaces/common';
import { $ } from '@/Engine/stateInstance';
import { ShelfSet } from '@/Engine/Wardrobe/ShelfSet';
import { findRod, getRodConnector, getShelfBrackets } from '@/lib/createModule';

export function returnInitialShelfState(shelfSet: ShelfSet) {
    const newTemplates = JSON.parse(JSON.stringify(shelfSet.templates));
    shelfSet.position = shelfSet.position.clone();

    if (shelfSet.templates.shelfBracketLeft &&
        shelfSet.templates.shelfBracketLeft.disabled) {
        newTemplates.shelfBracketLeft.disabled = false;
    }
    if (shelfSet.templates.shelfBracketRight &&
        shelfSet.templates.shelfBracketRight.disabled) {
        newTemplates.shelfBracketRight.disabled = false;
    }
    if (shelfSet.templates.rodHolderLeft &&
        shelfSet.templates.rodHolderLeft.disabled) {
        newTemplates.rodHolderLeft.disabled = false;
    }
    if (shelfSet.templates.rodHolderRight &&
        shelfSet.templates.rodHolderRight.disabled) {
        newTemplates.rodHolderRight.disabled = false;
    }
    if (shelfSet.templates.rodCapLeft &&
        shelfSet.templates.rodCapLeft.disabled) {
        newTemplates.rodCapLeft.disabled = false;
    }
    if (shelfSet.templates.rodCapRight &&
        shelfSet.templates.rodCapRight.disabled) {
        newTemplates.rodCapRight.disabled = false;
    }
    if (shelfSet.templates.rod &&
        shelfSet.templates.rod.disabled) {
        newTemplates.rod.disabled = false;
    }
    newTemplates.assets.forEach((item) => {
        if (item.type === 'rodCap')
            item.disabled = false;
        if (item.type === 'rodConnector') {
            item.disabled = true;
        }
        if (item.type === 'rod') {
            item.disabled = true;
        }
    });
    shelfSet.templates = newTemplates;
    shelfSet.updateModels(newTemplates);
    shelfSet.updatePartPosition();
}

export function updatePartsForAllShelves() {
    $.wardrobe.shelves
        .sort((shelf1, shelf2)=>shelf1.position.x - shelf2.position.x)
        .forEach((shelf)=>{

        if (shelf.type !== 'shelf') return;
        if (!shelf.position) return;
        const shelfSet = shelf as ShelfSet;
        returnInitialShelfState(shelfSet);

        const collisionShelf = $.checkShelfCollision(shelf, shelf.side) as ShelfSet;
        if (!collisionShelf) return;
        const collisionShelfSet = collisionShelf as ShelfSet;
        if (!collisionShelfSet.position) return;
        const secondCollisionShelf = $.checkShelfCollisionWithExclude(shelf, shelf.side, [ collisionShelf.uuid ]);


        let leftShelf: ShelfSet | null = null;
        let rightShelf: ShelfSet | null = null;
        if (collisionShelfSet.type === 'shelf')
            if (shelfSet.position.x < collisionShelfSet.position.x) {
                if (Math.abs(shelf.place - collisionShelf.place) < 3)
                    rightShelf = collisionShelfSet;
            } else {
                if (Math.abs(shelf.place - collisionShelf.place) < 3)
                    leftShelf = collisionShelfSet;
            }

        if (secondCollisionShelf &&
            secondCollisionShelf.type === 'shelf') {
            if (shelfSet.position.x < secondCollisionShelf.position.x) {
                if (Math.abs(shelf.place - secondCollisionShelf.place) < 3)
                    rightShelf = secondCollisionShelf as ShelfSet;
            } else {
                if (Math.abs(shelf.place - secondCollisionShelf.place) < 3)
                    leftShelf = secondCollisionShelf as ShelfSet;
            }
        }

        if (rightShelf?.side !== shelf.side && leftShelf?.side !== shelf.side) {
            return;
        }

        const newTemplates = JSON.parse(JSON.stringify(shelfSet.templates)) as wardrobeTemplates;
        const rightShelfRodDisable = false;
        // У правой полки в ассетах есть штанга
        const rightRodAssets = rightShelf?.templates.assets.find((item)=>item.type==='rod');
        const rodIsReplaced = rightRodAssets && !rightRodAssets.disabled;
        // Если у левой полки в ассетах есть штанга
        const leftRodAssets = leftShelf?.templates.assets.find((item)=>item.type==='rod');
        const leftIsReplaced = leftRodAssets && !leftRodAssets.disabled;

        if (rightShelf && rightShelf.side === shelf.side) {
                // Если полка справа совместима со штангой и полка только со штангой и у них разная глубина
            if (rightShelf.rodAvailable &&
                newTemplates.rod &&
                !newTemplates.shelf &&
                rightShelf.compatibilityDepth !== shelf.compatibilityDepth
            ) {
                // Заменяем держатель полки
                const newBrackets = getShelfBrackets(rightShelf.depth, shelf.color.replace('#',''));
                if (newBrackets) {
                    newTemplates.shelfBracketLeft = JSON.parse(JSON.stringify(newBrackets));
                    newTemplates.shelfBracketRight = JSON.parse(JSON.stringify(newBrackets));
                    shelf.compatibilityDepth = rightShelf.compatibilityDepth;
                    shelf.depth = rightShelf.depth;
                }
            }

            //Если полка справа со штангой
            if (rightShelf.templates.rod) {
                if (newTemplates.rodHolderRight)
                    newTemplates.rodHolderRight.disabled = true;
                if (newTemplates.rodCapRight) {
                    newTemplates.rodCapRight.disabled = true;
                }
                // Если полка со штангой
                if (newTemplates.rod) {
                    // Если штанги одинаковые, то заменяем на одну длинную
                    if (
                        !rodIsReplaced &&
                        rightShelf.templates.rod.compatibilityWidth === newTemplates.rod.compatibilityWidth &&
                        !([ '90', '120' ].includes(rightShelf.templates.rod.compatibilityWidth ?? ''))

                    ) {
                        // Ищем штангу двойного размера
                        const newRod = findRod(2*rightShelf.templates.rod.compatibilityWidth);
                        // Если есть такая штага, то выключаем штангу у полки (только для корзины)
                        // и добавляем штангу в ассеты (тоже только для корзины)
                        let found;
                        if (newRod) {
                            newTemplates.rod.disabled = true;
                            newTemplates.assets.forEach((item) => {
                                if (item.type === 'rod') {
                                    found = true;
                                    item.disabled = false;
                                }
                            });
                            if (!found)
                                newTemplates.assets.push(newRod);
                        }
                    } else {
                        // Включаем или добавляем соединитель штанг
                        let found;
                        newTemplates.assets.forEach((item) => {
                            if (item.type === 'rodConnector') {
                                found = true;
                                item.disabled = false;
                            }
                        });
                        const rodConnector = getRodConnector();
                        if (rodConnector && !found)
                            newTemplates.assets.push(rodConnector);
                    }
                }

            }

            if (newTemplates.shelfBracketRight)
                newTemplates.shelfBracketRight.disabled = true;

        }

        if (leftShelf && leftShelf.side === shelf.side) {
            // Если полка слева совместима со штангой и полка только со штангой и у них разная глубина
            if (leftShelf.rodAvailable &&
                newTemplates.rod &&
                !newTemplates.shelf &&
                leftShelf.compatibilityDepth !== shelf.compatibilityDepth
            ) {
                // Заменяем держатель полки
                const newBrackets = getShelfBrackets(leftShelf.depth, shelf.color.replace('#',''));
                if (newBrackets) {
                    const rightDisabled = newTemplates.shelfBracketRight?.disabled;
                    newTemplates.shelfBracketLeft = JSON.parse(JSON.stringify(newBrackets));
                    newTemplates.shelfBracketRight = JSON.parse(JSON.stringify(newBrackets));
                    if (newTemplates.shelfBracketRight)
                        newTemplates.shelfBracketRight.disabled = !!rightDisabled;
                    shelf.compatibilityDepth = leftShelf.compatibilityDepth;
                    shelf.depth = leftShelf.depth;
                }
            }

            //Если полка слева со штангой и полка со штангой
            if (leftShelf.templates.rod && newTemplates.rod) {

                // Если штанги одинаковые
                if (
                    (leftIsReplaced || !leftShelf.templates.rod.disabled) &&
                    leftShelf.templates.rod.compatibilityWidth ===
                    newTemplates.rod.compatibilityWidth
                ) {
                    // Ищем штангу двойного размера
                    const newRod = findRod(2*shelf.templates.rod.compatibilityWidth);
                    // Если есть такая штага, то выключаем штангу у полки (только для корзины)
                    if (newRod) {
                        newTemplates.rod.disabled = true;
                    }
                }
            }

            // Если у полки и у полки слева штанга
            if (newTemplates.rod &&
                leftShelf.templates.rod &&
                newTemplates.rodCapLeft
            ) {
                newTemplates.rodCapLeft.disabled = true;
                newTemplates.assets.forEach((item) => {
                    if (item.type === 'rodCap')
                        item.disabled = true;
                });
            }
        }

        shelfSet.templates = newTemplates;
        shelfSet.updateModels(newTemplates);
        shelfSet.updatePartPosition();
    });



}

export function shelfDocking(shelf: Shelf, collisionShelf: Shelf) {
    // Если возвращаем false, то означает что позиция запрещенная, применена не будет
    if (!shelf.position || !collisionShelf.position) return false;
    let shelfWithoutRod;
    if (collisionShelf.rodAvailable && !collisionShelf.items.rod && !collisionShelf.items.bracketCenterExtra)
        shelfWithoutRod = collisionShelf;

    const exclude = [ collisionShelf.uuid ];
    const secondCollisionShelf = $.checkShelfCollisionWithExclude(shelf, shelf.side, exclude);
    let thirdCollisionShelf = null;
    // returnShelfBrackets(shelf);
    // Если полки перекрываются
    const error = 0.01; // холостой ход полок в мм
    const firstPanelCollision =
        shelf.type === 'panel' &&
        collisionShelf?.type === 'panel';
    if (shelf.type === 'panel') return true;
    let secondPanelCollision = false;
    let thirdPanelCollision = false;
    const firstShelfDeltaX = Math.abs(shelf.position.x - collisionShelf.position.x);
    const firstShelfWidthSum = shelf.width/2 + collisionShelf.width/2;
    const firstOnSameRack = Math.abs(shelf.position.x - collisionShelf.position.x) < error;
    let firstOverlay =
        firstShelfDeltaX < firstShelfWidthSum - error || firstOnSameRack;
    if (firstPanelCollision)
        firstOverlay = firstOverlay && Math.abs(shelf.place - collisionShelf.place) < 12;
    let secondOveraly = false;
    let thirdOverlay = false;
    if (secondCollisionShelf) {
        exclude.push(secondCollisionShelf.uuid);
        thirdCollisionShelf = $.checkShelfCollisionWithExclude(shelf, shelf.side, exclude);
        secondPanelCollision =
            shelf.type === 'panel' &&
            secondCollisionShelf?.type === 'panel';
        const secondShelfDeltaX = Math.abs(shelf.position.x - secondCollisionShelf.position.x);
        const secondShelfWidthSum = shelf.width/2 + secondCollisionShelf.width/2;
        secondOveraly =
            (secondShelfDeltaX < secondShelfWidthSum - error ||
            Math.abs(shelf.position.x - secondCollisionShelf.position.x) < error);
        if (secondPanelCollision)
            firstOverlay = firstOverlay && Math.abs(shelf.place - secondCollisionShelf.place) < 12;
        if (secondCollisionShelf.type === 'shelf' && secondCollisionShelf.rodAvailable && !secondCollisionShelf.items.rod && !secondCollisionShelf.items.bracketCenterExtra) {
            if (shelfWithoutRod &&
                shelfWithoutRod.position.distanceTo(shelf.position) >
                secondCollisionShelf.position.distanceTo(shelf.position)
            )
                shelfWithoutRod = secondCollisionShelf;
        }
    }

    if (thirdCollisionShelf) {
        thirdPanelCollision =
            shelf.type === 'panel' &&
            thirdCollisionShelf?.type === 'panel';
        const thirdShelfDeltaX = Math.abs(shelf.position.x - thirdCollisionShelf.position.x);
        const thirdShelfWidthSum = shelf.width / 2 + secondCollisionShelf.width / 2;
        thirdOverlay =
            thirdShelfDeltaX < thirdShelfWidthSum - error ||
            Math.abs(shelf.position.x - thirdCollisionShelf.position.x) < error;
        if (thirdPanelCollision)
            firstOverlay = firstOverlay && Math.abs(shelf.place - secondCollisionShelf.place) < 12;
        if (thirdCollisionShelf.type === 'shelf' && thirdCollisionShelf.rodAvailable && !thirdCollisionShelf.items.rod && !thirdCollisionShelf.items.bracketCenterExtra) {
            if (shelfWithoutRod &&
                shelfWithoutRod.position.distanceTo(shelf.position) >
                thirdCollisionShelf.position.distanceTo(shelf.position)
            )
                shelfWithoutRod = thirdCollisionShelf;
        }
    }

    $.selectionBox.update();
    return true;
}

export function smartShelfCollision(shelf: Shelf, side: sides) {
    const collision = $.checkShelfCollision(shelf, side);
    return false;
}
